var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dialog", class: { active: _vm.isVisible } },
    [
      _c(
        "div",
        {
          staticClass: "dialog--content",
          class: "dialog--content-" + _vm.type,
        },
        [
          _vm.title ? [_c("h2", [_vm._v(_vm._s(_vm.title))])] : _vm._e(),
          _vm._v(" "),
          _vm.message
            ? [
                _c("p", { domProps: { innerHTML: _vm._s(_vm.message) } }, [
                  _vm._v(_vm._s(_vm.message)),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showActionButtons
            ? _c("p", { staticClass: "text-center" }, [
                _c(
                  "button",
                  {
                    staticClass: "button",
                    on: {
                      click: function ($event) {
                        return _vm.onClickAction("yes")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("yes")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button gray",
                    on: {
                      click: function ($event) {
                        return _vm.onClickAction("no")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("no")))]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "close-button",
              on: {
                click: function ($event) {
                  return _vm.onClickAction("close")
                },
              },
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }